import React from "react";

/** Courier tables: left-align data columns; only .act is right-aligned. */
const CourierTable = ({ children }) => (
  <div className="courier-table-wrap">
    <table className="list-table courier-table">{children}</table>
  </div>
);

export default CourierTable;
